import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.page.html',
  styleUrls: ['./email.page.scss'],
})
export class EmailPage implements OnInit {

  email: string;

  constructor(private modalCtrl: ModalController,
    private profileService: ProfileService) {
    this.email = "";
  }

  ngOnInit() {
    this.getEmail();
  }

  getEmail() {
    // this.email = this.profileService.currentUser.email;
    this.email = "test@test.de";
  }

  cancelChangeEmail() {
    this.modalCtrl.dismiss();
  }

  saveNewEmail() {
    // do save password
    // this.profileService.updatePassword("test1234", "test123");
    this.modalCtrl.dismiss();
  }

}
